import { getExchangeRates } from "../util/api";

const EXCHANGE_RATE_REQUEST = 'app/exchangeRate/EXCHANGE_RATE_REQUEST';
const EXCHANGE_RATE_SUCCESS = 'app/exchangeRate/EXCHANGE_RATE_SUCCESS';
const EXCHANGE_RATE_ERROR = 'app/exchangeRate/EXCHANGE_RATE_ERROR';

const initialState = {
    fetchRatesInProgress: false,
    fetchRatesError: null,
    exchangeRates: [],
};

export default function reducer(state = initialState, action = {}) {
    const { type, payload } = action;
    switch (type) {
        case EXCHANGE_RATE_REQUEST:
            return {
                ...state,
                fetchRatesInProgress: true,
                fetchRatesError: null
            };
        case EXCHANGE_RATE_SUCCESS:
            return {
                fetchRatesInProgress: false,
                exchangeRates: payload,
                fetchRatesError: null
            };

        case EXCHANGE_RATE_ERROR:
            return {
                ...state,
                fetchRatesInProgress: false,
                fetchRatesError: payload
            };

        default:
            return state;
    }
}

const exchangeRateRequest = () => ({ type: EXCHANGE_RATE_REQUEST });
const exchangeRateSuccess = (rates) => ({ type: EXCHANGE_RATE_SUCCESS, payload: rates });
const exchangeRateError = (error) => ({ type: EXCHANGE_RATE_ERROR, payload: error, error: true });


// Exchange rates are a global snapshot (refreshed server-side ~hourly) and are
// fetched by many mounts at once (CheckoutPage, FloatingCheckoutWidget, cart,
// listing, ...). Without a guard this produced request storms — dozens of
// `/api/stored-exchange-rates` calls in bursts, some failing under the
// self-inflicted load, which then broke price display at checkout. Dedupe
// on the client: reuse an in-flight request and skip if rates are still fresh.
// SSR keeps the original per-request behaviour.
let inFlightRatesPromise = null;
let lastRatesFetchAt = 0;
const RATES_CACHE_TTL_MS = 5 * 60 * 1000;

export const fetchExchangeRates = () => (dispatch, getState) => {
    const isClient = typeof window !== 'undefined';

    if (isClient) {
        const { exchangeRates } = getState()?.exchangeRate || {};
        const now = Date.now();
        if (Array.isArray(exchangeRates) && exchangeRates.length > 0 && now - lastRatesFetchAt < RATES_CACHE_TTL_MS) {
            return Promise.resolve(exchangeRates);
        }
        if (inFlightRatesPromise) {
            return inFlightRatesPromise;
        }
    }

    dispatch(exchangeRateRequest());

    const p = Promise.resolve()
        .then(() => getExchangeRates())
        .then(({ data }) => {
            if (isClient) lastRatesFetchAt = Date.now();
            dispatch(exchangeRateSuccess(data));
            return data;
        })
        .catch(err => {
            dispatch(exchangeRateError(err));
            return null;
        })
        .finally(() => {
            if (isClient) inFlightRatesPromise = null;
        });

    if (isClient) inFlightRatesPromise = p;
    return p;
};
